/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 数据对比
 */
let EnumDataCompare = {
	Close: 						new EnumItem('参与', 1),
	Open: 						new EnumItem('不参与', 2),
	...enumMixn
}
export default EnumDataCompare
